import React, { memo, forwardRef } from "react";
const SvgPhi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M16.392 28c-.57 0-1.032-.462-1.032-1.032v-4.536c-1.264-.112-2.376-.44-3.336-.984a5.924 5.924 0 01-2.232-2.256C9.264 18.232 9 17.104 9 15.808c0-1.312.248-2.44.744-3.384a5.434 5.434 0 012.16-2.256c.96-.56 2.112-.888 3.456-.984V5.032a1.032 1.032 0 112.064 0v4.152c1.28.112 2.392.448 3.336 1.008a5.924 5.924 0 012.232 2.256c.528.944.792 2.064.792 3.36 0 1.296-.256 2.424-.768 3.384a5.8 5.8 0 01-2.184 2.256c-.944.544-2.08.872-3.408.984v4.536c0 .57-.462 1.032-1.032 1.032zm-1.032-7.248v-9.864c-.976.096-1.776.344-2.4.744-.608.4-1.056.952-1.344 1.656-.272.688-.408 1.528-.408 2.52 0 .976.144 1.816.432 2.52a3.67 3.67 0 001.344 1.68c.608.4 1.4.648 2.376.744zm2.064 0c.96-.112 1.744-.368 2.352-.768a3.639 3.639 0 001.368-1.656c.304-.704.456-1.544.456-2.52 0-1.472-.344-2.616-1.032-3.432-.672-.816-1.72-1.304-3.144-1.464v9.84z"
      />
    </svg>
  );
});
SvgPhi.displayName = "SvgPhi";
const MemoForwardRef = memo(SvgPhi);
export default MemoForwardRef;
